import React from 'react'
import './Button.scss'
import clsx from 'clsx'

// Create a button component that passed all props to the button element and define the props type
// Add button variant for large, medium, small

export type TPropsButton = {
  size?: 'large' | 'medium' | 'small'
  variant?:
    | 'brand-primary'
    | 'brand-secondary'
    | 'brand-tertiary'
    | 'neutral-primary'
    | 'neutral-secondary'
    | 'neutral-tertiary'
    | 'danger-primary'
    | 'danger-secondary'
    | 'danger-tertiary'
    | 'success-primary'
  icon?: string
  loading?: boolean
  disabled?: boolean
}

const Button = (props: TPropsButton & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  const { size = 'medium', variant = 'brand-primary', icon, loading, children, ...rest } = props
  return (
    <button
      className={clsx(
        'tq-button',
        { 'tq-button--large': size === 'large' },
        { 'tq-button--medium': size === 'medium' },
        { 'tq-button--small': size === 'small' },
        { 'tq-button--brand-primary': variant === 'brand-primary' },
        { 'tq-button--brand-secondary': variant === 'brand-secondary' },
        { 'tq-button--brand-tertiary': variant === 'brand-tertiary' },
        { 'tq-button--neutral-primary': variant === 'neutral-primary' },
        { 'tq-button--neutral-secondary': variant === 'neutral-secondary' },
        { 'tq-button--neutral-tertiary': variant === 'neutral-tertiary' },
        { 'tq-button--danger-primary': variant === 'danger-primary' },
        { 'tq-button--danger-secondary': variant === 'danger-secondary' },
        { 'tq-button--danger-tertiary': variant === 'danger-tertiary' },
        { 'tq-button--success-primary': variant === 'success-primary' }
      )}
      {...rest}
    >
      <div className="tq-button-content">
        {icon && <i className={icon} />}
        {children}
        {loading && <i className="fa fa-spinner fa-spin" />}
      </div>
    </button>
  )
}

export default Button
